// master list of query keys for @tanstack/react-query
export const QUERY_KEYS = {
  wellListKey: 'wellList',
  wellSearchKey: 'wellSearch',
  filterListsKey: 'filterLists',
  orgIconsKey: 'orgIcons',
  mapMarkersKey: 'mapMarkers',
  weatherBackgroundsKey: 'weatherBackgrounds',
  geoLayerStatesKey: 'geojsonStates',
  geoLayerCountiesKey: 'geojsonCounties',
  geoLayerShalePlaysKey: 'geojsonShalePlays',
  geoLayerConvPlaysKey: 'geojsonConvPlays',
  wellDataKey: 'wellData',
  objectsOfInterestKey: 'useObjectsOfInterest',
  objectsOfInterestDropDownsKey: 'useObjectsOfInterestDropDowns',
  wellInsightsKey: 'wellInsights',
  userDatabaseAccessKey: 'userDatabaseAccess',
  unitSetMapKey: 'unitSetMap',
  unitSetListKey: 'unitSetList',
  apiConfigsKey: 'apiConfigs',
  apiConfigSchemaKey: 'apiConfigSchema',
  awsRegionsKey: 'awsRegions',
  wellSeekerFeatureUsageKey: 'wellSeekerFeatureUsage',
  awsRegionsDataKey: 'awsRegionsData',
  awsRegionSchemaKey: 'awsRegionSchema',
  innovaAdminUsersKey: 'innovaAdminUsers',
  innovaAdminNotificationOptionsKey: 'innovaAdminNotificationOptions',
  adminFeaturesListKey: 'adminFeaturesList',
  dataInsightsKey: 'analytics',
  acCacheKey: 'acCache',
  alertsDataKey: 'alertsData',
  wellInventoryKey: 'wellInventory',
  targetsDataKey: 'targetsData',
  rigDataKey: 'rigData',
  orgSpecificWellDataKey: 'orgSpecificWellData',
}
